import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const FavTable = ({
  data,
  meta,
  language,
  onEdit,
  onDelete,
  onView,
  onPageChange,
}) => {
  if (!meta) return null;

  const {
    current_page,
    last_page,
    from,
    to,
    total,
    prev_page_url,
    next_page_url,
  } = meta;

  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[1200px]">
        <thead className="bg-muted border-b">
          <tr>
            <th className="px-4 py-3 text-center">السيارة</th>
            <th className="px-4 py-3 text-center">الموديل</th>
            <th className="px-4 py-3 text-center">السنة</th>
            <th className="px-4 py-3 text-center">السعر</th>
            <th className="px-4 py-3 text-center">اللون</th>
            <th className="px-4 py-3 text-center">نوع الوقود</th>
            <th className="px-4 py-3 text-center">ناقل الحركة</th>
            <th className="px-4 py-3 text-center">المالك</th>
            <th className="px-4 py-3 text-center">الحالة</th>
            <th className="px-4 py-3 text-center">المنطقة</th>
            <th className="px-4 py-3 text-center">عدد المشاهدات</th>
            <th className="px-4 py-3 text-center">الوصف</th>
            <th className="px-4 py-3 text-center"></th>
          </tr>
        </thead>

        <tbody className="divide-y">
          {data?.map((item) => (
            <tr key={item.id} className="hover:bg-muted/50 text-sm">
              <td className="px-4 py-3 text-center">{item?.listing.car_brand?.name}</td>
              <td className="px-4 py-3 text-center">{item.listing?.car_model}</td>
              <td className="px-4 py-3 text-center">{item.listing?.car_year}</td>
              <td className="px-4 py-3 text-center">{item.listing?.price}</td>
              <td className="px-4 py-3 text-center">{item.listing?.color?.name}</td>
              <td className="px-4 py-3 text-center">{item.listing?.fuel_type?.name}</td>
              <td className="px-4 py-3 text-center">{item.listing?.gear_type?.name}</td>
              <td className="px-4 py-3 text-center">{item.listing?.owner}</td>
              <td className="px-4 py-3 text-center">{item.listing?.car_status}</td>
              <td className="px-4 py-3 text-center">{item.listing?.area?.area_name}</td>
              <td className="px-4 py-3 text-center">{item.listing?.views_counter}</td>

              {/* الوصف مع تقصير + Tooltip */}
              <td className="px-4 py-3 text-center max-w-xs">
                <div className="relative group cursor-pointer inline-block">
                  <span>
                    {item.description?.length > 100
                      ? item.listing?.description.slice(0, 100) + "..."
                      : item.listing?.description}
                  </span>
                  {item.listing?.description?.length > 100 && (
                    <div className="absolute z-10 hidden group-hover:block bg-black text-white text-xs rounded p-2 w-64 top-full mt-1 text-right shadow-lg">
                      {item.listing?.description}
                    </div>
                  )}
                </div>
              </td>

              {/* العمليات */}
              <td className="px-4 py-3">
                <div className="flex justify-center gap-2">
                  <button onClick={() => onView(item)} className="text-primary">
                    <Icon name="Eye" size={16} />
                  </button>
                
                  {onDelete && (
                    <button onClick={() => onDelete(item)} className="text-error">
                      <Icon name="Trash2" size={16} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center p-4 bg-muted/30 gap-3">
        <span className="text-sm text-text-secondary">
          {from}-{to} من {total}
        </span>

        <div className="flex gap-1 flex-wrap">
          <Button
            size="sm"
            variant="outline"
            disabled={!prev_page_url}
            onClick={() => onPageChange(current_page - 1)}
          >
            السابق
          </Button>

          {pages.map((page) => (
            <Button
              key={page}
              size="sm"
              variant={page === current_page ? "default" : "outline"}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ))}

          <Button
            size="sm"
            variant="outline"
            disabled={!next_page_url}
            onClick={() => onPageChange(current_page + 1)}
          >
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FavTable;